import { apiCall } from "./api";

const STORAGE_KEY = "roles_permissions_cache";

export async function refreshRolesCache() {
  try {
    const roles = await apiCall("GET", "/roles");
    const map = {};
    for (const r of roles || []) {
      if (r && r.name) {
        map[r.name] = Array.isArray(r.permissions) ? r.permissions : [];
      }
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    return map;
  } catch (e) {
    return null;
  }
}

export function getCachedRolePerms(roleName) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const map = JSON.parse(raw);
    if (map && Object.prototype.hasOwnProperty.call(map, roleName)) {
      return Array.isArray(map[roleName]) ? map[roleName] : [];
    }
    return null;
  } catch (e) {
    return null;
  }
}

export function clearRolesCache() {
  try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
}
